import React, { Component } from 'react';
import _ from 'underscore';
import TableComponentEnum from './../../utils/TableComponentEnum';

class TablePagination extends Component {
    static componentType = TableComponentEnum.TABLEPAGINATION;

    renderPaginationBar = () => {
        var self = this;
        var paginationBarElements = [];
        var pagingMetadata = this.props.pagingMetadata;
        // this is when we first initialize the page and no call is done to the api
        if (!pagingMetadata.startIndex) {
            pagingMetadata.page = 1;
            pagingMetadata.pageCount = 1;
        }
        _.each(_.range(Math.max(1, pagingMetadata.page-4), Math.min(pagingMetadata.pageCount + 1, pagingMetadata.page + 5)), function(i) {
            paginationBarElements.push(<li key={i} onClick={self.props.jumpToPage}
                                           className={' paginate_button ' + (i === pagingMetadata.page ? 'active' : '')}
                                           data-page={i}><a href="">{i}</a>
                                       </li>)
        });
        return paginationBarElements;
    };

    render() {
        var pagingMetadata = this.props.pagingMetadata;
        var paginationBarElements = this.renderPaginationBar();
        return <div className="row">
            <div className="col-md-12 col-sm-12 text-center">
                {pagingMetadata.startIndex ?
                <div>Showing {pagingMetadata.startIndex} to {pagingMetadata.endIndex > pagingMetadata.totalCount ? pagingMetadata.totalCount : pagingMetadata.endIndex} of { pagingMetadata.totalCount} entries</div>
                : <div>Showing 0 entries</div>}
                {pagingMetadata.totalShipments ?
                <div className="table-pagination-sum-items">Sum Total Shipments: {pagingMetadata.totalShipments}</div>
                : ""}
            </div>
            <div className="col-md-12 col-sm-12 text-center">
                <div>
                    <ul className="pagination">
                        <li onClick={this.props.jumpToFirstPage} className={'paginate_button first ' + (pagingMetadata.page === 1 ? 'disabled' : '') }>
                            <a href=""><i className="fa fa-angle-double-left"></i></a>
                        </li>
                        <li onClick={this.props.goBackToPage} className={'paginate_button previous ' + (pagingMetadata.page === 1 ? 'disabled' : '') }>
                            <a href=""><i className="fa fa-angle-left"></i></a>
                        </li>
                        { paginationBarElements }
                        <li onClick={this.props.goForwardToPage} className={'paginate_button next' + (pagingMetadata.pageCount ? pagingMetadata.page === pagingMetadata.pageCount ? ' disabled' : '' : ' disabled' )}>
                            <a href=""><i className="fa fa-angle-right"></i></a>
                        </li>
                        <li onClick={this.props.jumpToLastPage} className={'paginate_button last' + (pagingMetadata.pageCount ? pagingMetadata.page === pagingMetadata.pageCount ? ' disabled' : '' : ' disabled' )}>
                            <a href=""><i className="fa fa-angle-double-right"></i></a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    }
}
export default TablePagination;